/**
* 单选-日期组合-司机流水
* */
<template>
  <div id="customRadioDate">
    <el-radio-group v-model="radio" type="button" style="margin-right: 16px">
      <el-radio-button
        :label="item.value"
        v-for="(item, index) in radioGroup"
        :key="index"
        >{{ item.label }}
      </el-radio-button>
    </el-radio-group>

    <p style="line-height: 2; font-size: 14px; margin-right: 6px">统计时间:</p>
    <el-date-picker
      type="date"
      @change="dateChangeFn"
      v-model="date[0]"
      :format="format"
      :picker-options="pickerOptions"
      placeholder="开始时间"
      style="width: 140px; margin-right: 16px; height: 28px"
    >
    </el-date-picker>

    <el-date-picker
      type="date"
      @change="dateChangeFn"
      v-model="date[1]"
      :format="format"
      placeholder="结束时间"
      :picker-options="pickerOptions"
      style="width: 140px; height: 28px"
    >
    </el-date-picker>
  </div>
</template>

<script>
export default {
  name: "customRadioDate",
  props: {
    // 日期格式，默认值为'yyyy/MM/dd'
    format: {
      default() {
        return "yyyy/MM/dd";
      },
    },
    // 单选框组数据
    radioGroup: {
      default() {
        return [
          { value: 1, label: "昨日" },
          { value: 2, label: "最近7天" },
          { value: 3, label: "最近30天" },
          { value: 4, label: "最近半年" },
          { value: 5, label: "最近一年" },
          { value: 6, label: "从始至终" },
        ];
      },
    },
  },
  data() {
    return {
      // 选择的时间类型
      radio: this.radioGroup[0].value,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e7; //设置选择今天之前的日期（不能选择当天）
        },
      },
      // 日期选择器的值
      date: [],
    };
  },
  watch: {
    /**
     * 单选框组数据变化
     */
    radio: {
      handler(val) {
        if (val) {
          let params = {
            timeType: this.radio,
          };
          this.date = [];
          this.$emit("changeFn", params);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    /**
     * 日期选择器发生变化时触发
     */
    dateChangeFn() {
      if (this.date && this.date[0] && this.date[1]) {
        let year = this.date[0].getFullYear();
        let maxYear = year + 1;
        let maxDate = new Date(this.date[0]).setFullYear(maxYear);
        let step = maxDate - this.date[0];
        if (this.date[1] < this.date[0]) {
          this.$message.warning("开始时间选择时不能大于结束时间！");
          this.date = [];
          this.radio = this.radioGroup[0].value;
          return;
        } else if (this.date[1] - this.date[0] > step) {
          this.$message.warning("最多只能筛选1年的统计！");
          this.date = [];
          this.radio = this.radioGroup[0].value;
          return;
        }
        this.radio = "";
        let time = {
          startTime: Date.parse(new Date(this.date[0])) / 1000,
          endTime: Date.parse(new Date(this.date[1])) / 1000 + 24 * 60 * 60 - 1,
        };
        this.$emit("changeFn", time);
      } else if (!this.date[0] && !this.date[1]) {
        this.radio = this.radioGroup[0].value;
      }
    },
  },
};
</script>

<style lang="less">
#customRadioDate {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;

  .el-radio-group {
    margin-bottom: 0;
    margin-right: 16px;
    background: #f5f7fa;
    border-radius: 8px;
    padding: 4px;
    display: inline-flex;
  }

  .el-radio-button {
    margin: 0 2px;
    
    .el-radio-button__inner {
      background: transparent;
      border: none;
      border-radius: 6px;
      padding: 8px 12px;
      color: #606266;
      font-size: 14px;
    }
    
    &.is-active .el-radio-button__inner {
      background: #2B77FF;
      color: #fff;
      box-shadow: none;
    }
  }

  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #2B77FF;
    color: #fff;
    border-color: #2B77FF;
    box-shadow: none;
  }
  
  p {
    margin: 0;
    color: #606266;
  }
  
  .el-date-editor {
    .el-input__inner {
      border-radius: 6px;
    }
  }
}
</style>
